<div dialog-header>
  <h4>Quote Saved!</h4>
  <button class="close-btn" (click)="close()">
    <app-icon name="cross" width="16px" height="16px" />
  </button>
</div>

<app-icon name="circle_checkmark" width="75px" height="75px" />
<p>Your Quote has been saved Successfully. Would you like to also print the quote?</p>

<div dialog-actions>
  <button ui-button type="info" (click)="printQuote()">Print</button>
  <button ui-button type="secondary" (click)="close()">Continue</button>
</div>
